/*
* Helper class for Actis Reporting.
*
*/
import { getUserRole } from "@utils/utilities";
export class ActisReporting {
  constructor(category) {
    this.category = category;
    this.push = this.push.bind(this);
  }
  // allow this to pass a event category
  push(obj) {
    if (window.pushEvent) {
      this.binder = this.__proto__.binder;
      if (obj?.metadata) {
        obj.metadata = JSON.stringify(obj.metadata) || "";
      }
      window.pushEvent({
        ...obj,
        "activityMeta": obj.activityMeta,
        "category": this.category,
        "userId": this.binder.userId || "",
        "firstName": this.binder.firstName || "",
        "lastName": this.binder.lastName || "",
        "email": this.binder.email?.toLowerCase() || "",
        "companyName": this.binder.companyName || "",
        "orgId": this.binder.orgId || "",
        "userType": getUserRole(this.binder.roles) || "",
      }, "mercury-firehose");
    }
  }
}

export const ACTIS_REPORTING = {
  BINDER: null,
  LOGIN: new ActisReporting("Login"),
  "ham-menu": new ActisReporting("Navigation from Gcom Hamburger"),
  "hp-df": new ActisReporting("Navigation from Gcom Promo Card"),
  "shortcut-nav": new ActisReporting("Navigation from Gcom Apptray"),
  "gcom-search-popular": new ActisReporting("Navigation from Gcom Popular Panel"),
  "my-tools": new ActisReporting("Navigation from Gcom MyTools"),
  "ai-microsite": new ActisReporting("Navigation from AI Microsite"),
  "tool-wrapper": new ActisReporting("Navigation from AI UCI Tool Wrapper"),
  "share-email": new ActisReporting("Share CTA - Email Link"),
  "share-scorecard": new ActisReporting("Email - View Scorecard"),
  HOME_BREADCRUMBS: new ActisReporting("Home Navigation from breadcrumb"),
  SEARCH: new ActisReporting("Search"),
  FILTER: (param) => new ActisReporting(`${param} Filter`),
  CARDS: new ActisReporting("Use Case Cards"),
  SAVE_DROPDOWN_OPEN: new ActisReporting("User opens save modal for Use Case"),
  SAVE_USE_CASE: (param) => new ActisReporting(`Save ${param}`),
  UNSAVE_USECASE: (param) => new ActisReporting(`Unsaved ${param}`),
  VIEW_MORE_USECASES: new ActisReporting("View More on Discovery"),
  DOWNLOAD_PPT: new ActisReporting("Download Use Case PPT"),
  UNDO_TOASTER: new ActisReporting("Undo toaster message "),
  SUCCESS_TOASTER: new ActisReporting("Dashboard link on toaster message"),
  MAX_LIMIT_SUCCESS_TOASTER: new ActisReporting("Save use case limit reached."),
  EXPERT_ENQUIRY: new ActisReporting("Connect with Gartner Experts"),
  DOWNLOAD_SCORECARD_EXCEL: new ActisReporting("Download scorecard"),
  DOWNLOAD_SCORECARD_PPT: new ActisReporting("Download scorecard .ppt"),
  GRAPH: new ActisReporting("Graph view"),
  GRAPH_MODAL: new ActisReporting("Graph view - Modal"),
  SCORE_CARD_PAGINATION: (param) => new ActisReporting(`Score Card view - ${param}`),
  BLANK_SCORE_CARD: new ActisReporting("Scorecard Blank state - Browse Use Cases"),
  SIDE_PANEL: (param) => new ActisReporting(`${param} - left hand panel`),
  INTERCOM: (param) => new ActisReporting(`Intercom - dialog ${param}`),
  GARTNER_ASSESSMENT_EXPLAINED: new ActisReporting(`Gartner's Assessment Explained`),
  CASE_STUDY_SOURCE: (param) => new ActisReporting(`Case Study Source ${param}`),  
  HOW_SCORING_WORKS: new ActisReporting(`How Scoring Works`),
  CUSTOMIZE_WEIGHTS_CTA: new ActisReporting(`Customize Weights`),
  VIEW_WEIGHTS_CTA: new ActisReporting(`Custom Weights callout - View Weights`),
  DISMISS_CTA: new ActisReporting(`Custom Weights callout - Dismiss`),
  RESET_TO_DEFAULT_CTA: new ActisReporting(`Reset to Default`),
  BACK_TO_SCORECARD_CTA: new ActisReporting(`Customize Weights - Back to Scorecard`),
  SAVE_PARAMETER_CTA: new ActisReporting(`Save Paramater Weights : Overall`),
  SCORECARD_CATEGORY_TOOLTIP: new ActisReporting(`Use Case Category tooltip`),
  ADD_TO_GRAPH_CHECKBOX: (param) => new ActisReporting(`Use Case ${param} graph`),
  SCORECARD_EDIT_ICON: new ActisReporting(`Click on Edit icon`),
  SCORECARD_EDIT_SAVE_CTA: new ActisReporting(`Save Edited use case icon`),
  SCORECARD_EDIT_CANCEL_CTA: new ActisReporting(`Cancel edited use case`),
  SCORECARD_EDIT_DROPDOWN_OPTIONS: (param) => new ActisReporting(`Change of ${param} parameter`),
  SCORECARD_USE_CASE_NAME_LINK: new ActisReporting(`User clicks on Use Case Name`),
  USE_CASE_DETAILS_SIDE_DRAWER_BACK_TO_SCORECARD: new ActisReporting(`User clicks on back to scorecard`),
  USE_CASE_DETAILS_SIDE_DRAWER_VIEW_MORE_DETAILS: new ActisReporting(`User clicks on View Use Case details`),
  USE_CASE_DETAILS_SIDE_DRAWER_SAVE_UNSAVE_USECASE: (param) => new ActisReporting(`User clicks on ${param} on right hand panel`),
  FILTER_CHIPS: (param) => new ActisReporting(`User clicks on '${param}' tab`),
  WHATS_NEXT_LINK: (param) => new ActisReporting(`What's Next - ${param}`),
  USE_CASE_DETAILS_TOOLTIP_DEFINATIONS: (param) => new ActisReporting(`User clicked on '${param}' tooltip definitions`),
  USE_CASE_DETAILS_SHARE_CTA: (param) => new ActisReporting(`Share CTA - Use Case Details ${param}`),
  SCORECARD_CLICK: new ActisReporting(`Scorecard Click`),
  DASHBOARD_ELLIPSIS_YOUR_TEAM: new ActisReporting(`Dashboard Ellipsis - Your Team`),
  DASHBOARD_ELLIPSIS_RENAME_SCORECARD: new ActisReporting(`Dashboard Ellipsis - Rename Scorecard`),
  SCORECARD_MANAGE_CTA: new ActisReporting(`Scorecard - Edit Icon`),
  SCORECARD_ADD_MORE_CTA: new ActisReporting(`Add More Use Cases`),
  SCORECARD_RENAME_SCORECARD_CTA: new ActisReporting(`Rename Scorecard`),
  RENAME_SCORECARD_SAVE_CTA: new ActisReporting(`Rename Scorecard  - Modal ; Save`),
  RENAME_SCORECARD_CANCEL_CTA: new ActisReporting(`Rename Scorecard  - Modal ; Cancel`),
  CREATE_NEW_SCORECARD_CTA: new ActisReporting(`Create New Scorecard - CTA`),
  CREATE_NEW_SCORECARD_CREATE_CTA: new ActisReporting(`Create New Scorecard Modal - Create`),
  CREATE_NEW_SCORECARD_CANCEL_CTA: new ActisReporting(`Create New Scorecard  Modal - Cancel`),
  YOUR_TEAM_DRAWER_SEND_INVITE: (param) => new ActisReporting(`Team Management Modal - Send Invite ;  ${param}`),
  YOUR_TEAM_DRAWER_DELETE_REMOVE: new ActisReporting(`Team Management Modal - Delete ; Remove`),
  YOUR_TEAM_DRAWER_DELETE_CANCEL: new ActisReporting(`Team Management Modal - Delete ; Cancel`),
  YOUR_TEAM_ROLES_PERMISSIONS: new ActisReporting(`Learn About Roles and Permisssions`),
  SAVE_USECASE_MODAL: new ActisReporting(`User opens save modal for Use Case`),
  USE_CASE_ANALYST_NAME: new ActisReporting(`Analyst Name`),
  USE_CASE_RESEARCH_URL: new ActisReporting(`Research URL`),
  CREATE_NEW_SCORECARD_SAVE_MODAL_CTA: new ActisReporting(`Create New Scorecard - Save Modal`),
  DASHBOARD_ELLIPSIS_DELETE_SCORECARD: new ActisReporting(`Delete Scorecard`),
  DASHBOARD_ELLIPSIS_LEAVE_SCORECARD: new ActisReporting(`Leave Scorecard`),
  FILTER_SCORECARD_APPLY_CTA: new ActisReporting(`Filter Scorecard - Apply`),
  FILTER_SCORECARD_CLEAR_CTA: new ActisReporting(`Filter Scorecard - Clear filter`),
  SCORECARD_FILTER_CTA: new ActisReporting(`Manage - Filter Scorecard`),
  LANDING_TOGGLE_VIEW: (param) => new ActisReporting(`Landing Page Toggle - ${param} View`),
  USE_CASE_DETAILS_PAGE_LOAD: new ActisReporting(`Use Case Details Page Load`),
  CASE_EXAMPLE_VIEWED: new ActisReporting(`Case Study Viewed`),
  CASE_EXAMPLE_CLOSED: new ActisReporting(`Case Study accordion closed`),
  SCORING_BREAKDOWN_CTA: new ActisReporting(`Scoring breakdown on Scorecard`),
  RELATED_USE_CASES: new ActisReporting(`Related Use Cases click`),
  TABS_NAVIGATION: (param) =>  new ActisReporting(`${param} Tab`),
  CASE_EXAMPLES_FILTER: (param) => new ActisReporting(`${param} Filter - Case Examples`),
  CASE_EXAMPLES_CHIPS: (param) => new ActisReporting(`View ${param} tab on Case Examples`),
  VIEW_MORE_CASE_EXAMPLES: new ActisReporting(`View More - Case Examples`),
  SAVE_UNSAVE_CTA_CASE_EXAMPLES: (param) => new ActisReporting(`${param} - Case Example Page`),
  CASE_EXAMPLES_NO_RESULTS_CTA: new ActisReporting(`Browse available Case Examples`),
  CASE_EXAMPLES_SEARCH: new ActisReporting(`Search - Case Example`),
  SAVE_UNSAVE_CTA_CASE_EXAMPLES_DETAILS: (param) => new ActisReporting(`${param} - Case Example Detail Page`),
  CASE_EXAMPLES_DETAILS_PAGE_LOAD: new ActisReporting(`Case Examples Details Page Load`),
  CASE_EXAMPLES_DETAILS_DOWNLOAD_PPT: new ActisReporting(`Download Case Example .ppt`),
  CASE_EXAMPLES_DETAILS_SHARE_CTA: new ActisReporting(`Share - open modal`),
  CASE_EXAMPLES_DETAILS_SHARE: new ActisReporting(`Share Case Example`),
  HOME_PAGE_FEATURED_USE_CASES_CARD_CLICK: new ActisReporting("Featured Use Cases - Card click"),
  HOME_PAGE_FEATURED_USE_CASES_VIEW_ALL: new ActisReporting("Featured Use Cases - View All"),
  HOME_PAGE_ASSESSMENTS_RADIO_TOGGLE: new ActisReporting("Assessments - Industry/Function toggle"),
  HOME_PAGE_ASSESSMENTS_IND_FUN_DROPDOWN: new ActisReporting("Assessments - Dropdown (Industry/Function)"),
  HOME_PAGE_ASSESSMENTS_ASSESSNENT_DROPDOWN: new ActisReporting("Assessments - Assessment Name"),
  ASSESSMENTS_CLEAR_SELECTION: new ActisReporting("Assessments - Clear Selection"),
  HOME_PAGE_ASSESSMENTS_VIEW_ASSESSMENT: new ActisReporting("Assessments - View Assessment"),
  HOME_PAGE_ASSESSMENTS_TOOGLETIP: new ActisReporting("Toggletip for Gartner Assessment Section"),
  HOME_PAGE_GO_TO_ASSESSMENTS: new ActisReporting("New Banner for Assessments on HomePage"),
  HOME_PAGE_FEATURED_CASE_EXAMPLES_CARD_CLICK: new ActisReporting("Featured Case Examples - Card click"),
  HOME_PAGE_FEATURED_CASE_EXAMPLES_VIEW_ALL: new ActisReporting("Featured Case Examples - View All"),
  USE_CASE_DETAILS_ASSESSMENT_CALLOUT: new ActisReporting("Assessment Callout - Use Case details"),
  DASHBOARD_ASSESSMENT_CHIP_CLICK: (param) => new ActisReporting(`${param}`),
  DASHBOARD_GARTNER_ASSESSMENT_DROPDOWN: new ActisReporting(`Gartner's Assessment- Industry/Function dropdown`),
  DASHBOARD_GARTNER_ASSESSMENT_CLICK: new ActisReporting(`Gartner Assessment Click`),
  GARTNER_ASSESSMENT_DETAILS_VIEW_INSIGHTS: new ActisReporting(`Gartner Assessment - View Insights`),
  GARTNER_ASSESSMENT_DETAILS_ANALYST_CLICK: new ActisReporting(`Gartner Assessment - analyst click`),
  GARTNER_ASSESSMENT_DOWNLOAD_PPT: new ActisReporting(`Download Gartner Assessment - .ppt`),
  GARTNER_ASSESSMENT_PAGE_LOAD: new ActisReporting(`Gartner Assessment - Page Load`),
  ADD_TO_ASSESSMENT_DROPDOWN_OPEN: (param) => new ActisReporting(`Add to Assessment - Modal Open_${param}`),
  ADD_TO_ASSESSMENT_ADDED_SCORECARD: (param) => new ActisReporting(`Add to Assessment - Added to Scorecard_${param}`),
  ADD_TO_ASSESSMENT_CREATE_NEW_ASSESSMENT: (param) => new ActisReporting(`Create New Assessment_${param}`),
  GRAPH_SHOW_HIDE_LABELS: (param) => new ActisReporting(`Tick Box - ${param} Labels`),
  GRAPH_DOT_CLICK: new ActisReporting(`Use Case dot click`),
  GRAPH_VIEW_DETAILS_CTA: new ActisReporting(`Use Case - View Details`),
  IMPORT_USE_CASES_CTA: new ActisReporting(`Import use cases`),
  KEEP_YOUR_USE_CASE_CTA: new ActisReporting(`Keep your use case`),
  REPLACE_WITH_GARTNER_CTA: new ActisReporting(`Replace with Gartner`),
  FINISH_AND_SCORE_CTA: new ActisReporting(`Finish or Finish & Score Later`),
};
